import { render } from "./RenewButtons.vue?vue&type=template&id=0b528b93"
import script from "./RenewButtons.vue?vue&type=script&lang=js"
export * from "./RenewButtons.vue?vue&type=script&lang=js"

import "./RenewButtons.vue?vue&type=style&index=0&id=0b528b93&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__